export default {
  //search-company
  people: "潛在客戶",
  companies: "公司",
  clearAll: "清除所有",
  searchProspects: "搜索...",
  //actions
  isFoundIn: "在 ",
  isNotFoundWithinAnyLists: "未在任何列表中找到",
  l: " 列表",
  remove: "移除",
  saveToLists: "保存到列表",
  DeleteFailed: "刪除失敗",
  //delete dialog
  areYouSureYouWantToDeleteThisRecord: "您確定要刪除此記錄嗎？",
  proceedingWithDeletionWillResultInPermanentRemovalOfTheList:
    "進行刪除將導致該列表永久移除。",
  byCancelingYouEnsureThatNoListsWillBeRemoved:
    "通過取消，您可以確保不會移除任何列表。",
  //export dialog
  holdOnWereGeneratingYourExport: "請稍候，我們正在生成您的導出文件。",
  UseThisButtonOnlyIfYouWishToCancelYourAction:
    "僅在您希望取消操作時使用此按鈕。",
  //save search pop
  saveSearch: "保存搜索",
  newSaveSearch: "新保存搜索",
  UpdateSavedSearch: "更新已保存搜索",
  enterNewSearchName: "輸入新搜索名稱",
  visibility: "可見性",
  manageWhoCanSeeYourSavedSearch: "管理誰可以查看您的已保存搜索",
  private: "私有",
  onlyYouCanSeeYourSavedSearch: "只有您可以查看您的已保存搜索",
  everyoneCanSeeYourSavedSearch: "每個人都可以查看您的已保存搜索",
  pinSavedSearch: "釘選已保存搜索",
  findSavedSearch: "查找已保存的搜索",
  enterSavedSearchName: "輸入已保存搜索名稱",
  duplicate: "重複",
  update: "更新",
  enterATitleForYourCard: "為您的卡片輸入標題",
  enterYourCardNumber: "輸入您的卡號",
  digit: "3位數",
  provideYourCompleteAddress: "提供您的完整地址",
  selectYourCountry: "選擇您的國家",
  //add credits pop
  ClickTheButtonBelowToAddMoreCredits: "點擊下面的按鈕以添加更多信用點數！",
  PleaseEnterTheAmountYouLikeToTopUpToYourCredit: "請輸入您希望充值的金額",
  //companyLink\contactBtn\functionBtn
  more: "更多",
  verified: "已驗證",
  GetEmailSuccessfully: "成功獲取電子郵件",
  CopySuccessfully: "成功複製",
  recorded: "已記錄",
  implement: "實施",
  sequence: "工作流程",
  of: "  總條數：",
  toAssistYouEffectivelyWeRequireFurtherDetailsAbout:
    "為了有效協助您，我們需要進一步了解您的搜索偏好。請利用左側面板中的篩選選項來指定您所需的標準，以便我們能夠精煉搜索結果，並為您提供符合要求的目標。",
  //filter
  all: "所有",
  my: "我的",
  team: "團隊",
  lists: "列表",
  employees: "員工",
  technologies: "技術",
  socialmedia: "社交媒體",
  enterSocialMedia: "輸入社交媒體",
  noResultsFound: "未找到結果",
  searchCompanies: "搜索公司",
  filters: "篩選器",
  enterCompanies: "輸入公司名稱",
  accountHqLocation: "帳戶總部位置",
  CityStateCountryZIP: "城市/州/國家/郵政編碼",
  enterLocations: "輸入地點",
  revenue: "收入",
  chooseARangeOfRevenue: "選擇收入範圍",
  ofRevenueIsUnknown: "收入未知",
  technology: "技術",
  category: "類別",
  categories: "類別",
  enterCategories: "輸入類別",
  enterTechnologies: "輸入技術",
  enterIndustries: "輸入行業",
  employee: "員工",
  predefinedRange: "預定義範圍",
  ofEmployeesIsUnknown: "員工數量未知",
  enterNames: "輸入姓名",
  jobTitle: "職位名稱",
  searchForAJobTitle: "搜索職位名稱",
  founded: "成立時間",
  chooseARangeOfFoundedTime: "選擇成立時間範圍",
  from: "從",
  to: "到",
  specialties: "專業領域",
  enterSpecialties: "輸入專業領域",
  location: "地點",
  excludedLocationsLabel: '地點 [排除]',
  location_exclude: "[排除]",
  total: "總計",
  department: "部門",
  EnterDepartments: "輸入部門",
  JobTitle: "職位名稱",
  EnterJobTitles: "輸入職位名稱",
  ManagementLevel: "管理層級別",
  EnterManagementLevels: "輸入管理層級別",
  AccountHQ: "帳戶總部",
  ContactHQ: "聯絡總部",
  departmentFunction: "部門功能",
  EnterJobFunctions: "輸入職務功能",
  enterNamesAndPressTheEnterKey: "輸入姓名並按Enter鍵...",
  EnterJobTitlesAndPressTheEnterLKey: "輸入職位，然後按Enter鍵...",
  filterInclude: "包含",
  filterSelectAll: "全選",
  filterDeselectAll: "取消全選",
  filterRegionOther: "其他",
  filterRegionAsiaPacific: "亞太地區",
  filterRegionSouthAsia: "南亞",
  filterRegionCentralAsia: "中亞",
  filterRegionMiddleEast: "中東",
  filterRegionEurope: "歐洲",
  filterRegionAfrica: "非洲",
  filterRegionAmerica: "美洲",
  contactDetails: "聯絡方式",
  filterMustContain: "必須包含",
  filterWorkEmail: "工作電子郵件",
  filterPersonalEmail: "個人電子郵件",
  filterPhone: "電話號碼",
  filterHasEmail: "有電子郵件",
  filterHasPhone: "有電話號碼",
  filterExcludeWithoutContact: "排除沒有聯絡方式的聯絡人",
  pleaseSelectRange: "請選擇範圍",
  exclude_locations: "排除位置",
  filterExclude: "排除",

  //table
  selectAllCompanies: "選擇所有公司",
  selected: "已選擇",
  export: "導出",
  industry: "行業",
  keywords: "關鍵字",
  companyLocation: "公司位置",
  action: "操作",
  contact: "聯絡人",
  Title: "職稱",
  clearSelection: "清除選擇",
  selectNumberOfCompanies: "選擇公司數量",
  maxCompanies: "最多公司數量",
  youCanOnlySelectAMaximumOf25Companies: "您最多只能選擇25家公司。",
  UpgradeYourPlanNow: "立即升級您的計劃！",
  viewPlans: "查看計劃",
  applySelection: "應用選擇",
  selectNumberOfProspects: "選擇潛在客戶數量",
  maxProspects: "最多潛在客戶數量",
  maxProspectsPerCompany: "每家公司最多潛在客戶數",
  youCanOnlySelectAMaximumOf25Prospects: "您最多只能選擇25個潛在客戶。",
  PleaseSelectTheDataToBeExported: "請選擇要導出的數據",
  overview: "概覽",
  genericContacts: "通用聯絡人",
  size: "規模",
  contactLocation: "聯絡人位置",
  pleaseSelectItems: "請選擇操作項",
  specialties: "專長",
  moreSpecialty: "更多{count}項專長",


  // 新UI
  prospectsSearch: "潛在客戶搜索",
  companiesSearch: "公司搜索",
  savedSearches: "保存的搜索",
  savedLists: "已保存清單",

  // saved list and saved searches
  sortAndFilter: "排序和篩選",
  sortBy: "排序方式",
  filterAll: '所有',
  filterPrivate: '私人的',
  filterTeam: '團隊',
  searchSavedLists: "搜索已保存的清單",
  savedSearchName: "已保存的搜索名稱",
  noFilteringOptionsAvailable: "沒有可用的篩選選項",
  manageWhoCanSeeThisSearch: "管理誰可以查看此搜索",
  noSavedSearchesMatchYourQuery: "沒有保存的搜索與您的査詢匹配。 嘗試使用不同的關鍵字或檢查拼寫。",
  onlyU: "只有您",
  anyoneOnTheTeam: "團隊中的任何人",
  createNewList: "創建新列表",
  groupTeam: "團隊",
  groupPersonal: "個人",
  manageWhoCanViewThisList: "管理誰可以查看此清單",
  enterAListName: "輸入一個清單名稱",
  savedList: "已保存清單",
  listName: "清單名稱",
  saveContactsTo: "將連絡人保存到",
  contactEmails: "聯繫電子郵件",
  contactPhones: '聯繫電話',
  unlockContactDetails: "解鎖連絡人詳細資訊",
  getContactInfo: '取得聯繫資訊',
  contactDetailsAreOnTheWay: "聯繫方式正在路上",
  noDataAvailable: '無可用數據',
  accessEmails: "兌換郵件",
  accessPhoneNumber: "兌換電話",
  accessPhoneNumbersAndEmails: "兌換郵件和電話",

  redemptionComplete: "兌換完成！",
  bulkRedeemProcessing: "批量兌換處理中...",
  notifyMeWhenCompleted: "完成後通知我",
  expectedTime: "預計時間：",
  redeemSeconds: "{count}秒",
  redeemLoading: "加載中...",
  estimatedCharge: "預計費用：{count}信用點數",

  estimatedCost: "估計花費： {count} 信用點數",
  finalChargeBasedOnRequest: "最終費用可能因請求的成功完成而有所不同",
  showLess: "顯示較少",
  exportLeadsToCSV: "匯出CSV",
  exportComplete: "匯出完成！",
  exporting: "匯出中。。。",
  pleaseSelectTheFieldsThatNeedToBeExported: "請選擇需要匯出的欄位",
  exportLeads: "您即將匯出{count}潛在客戶。 這可能需要一些時間，具體取決於您選擇的大小。| 您即將匯出{count}個潛在客戶。 這可能需要一些時間，具體取決於您選擇的數量。",
  dataFieldsToInclude: "要包含的數據欄位",
  savedListRecords: '{count}條記錄',
  deleteList: "删除清單",
  actionCannotBeUndone: "您確定要删除此清單嗎？ 此操作無法撤銷。",
  selectedContactsNumber: "{count} 個所選的連絡人",
  btnSave: "已存清單",
  btnUnsave: "取消保存",
  specialties: '專業',
  selectCompanyNumber: "根據您當前的計畫選擇{count}家公司。",
  selectPeopleNumber: "使用您目前的方案向上選擇{count}個潛在客戶。",
  upgradeNowToAccessMore: "立即升級以訪問更多內容！",
  selectAll: "全部",
  selectThisPage: '當前頁',
  selectCustomize: '自定義',
  pleaseSelectTheFilteringType: "請選擇篩選類型",
  theQuantityCannotBeZero: '數量不能為0',
  filterSearch: "篩選搜尋",
  view: "查看",
  deleteSavedSearch: "删除已保存的搜索",
  deleteThisSavedSearch: "您確定要删除此已保存的搜索嗎？ 此操作無法撤銷。",
  createASequenceToStartAutomatingYourOutreach: "創建一個序列來開始自動化您的外展，並在準備就緒時在此處添加項目。",
  unsaveThemFromHere: "如果選定的潛在客戶已被儲存，您可以在此處取消儲存。",
  createAListToSaveAndOrganizeProspects: "創建一個清單來保存和組織您的潛在客戶",
  savedFilters: "已保存的篩選",
  viewResults: "查看搜尋結果",


  // search empty
  resultNoResultsFound: "未找到結果",
  noContactsThatMatchYourSearch: "您的蒐索或篩選器沒有匹配項。 嘗試更改篩檢程式或使用不同的關鍵字。",
  requestTimedOut: "請求超時",
  theServerIsCurrentlyBusy: "服務器當前正忙，我們無法加載結果。 請嘗試刷新頁面。",
  btnRefresh: "刷新",

  // tooltip
  tooltipRedeemEmail: "兌換電子郵件",
  tooltipRedeemPhone: "兌換電話號碼",
  tooltipRedeemEmailAndPhone: "兌換全部",
  tooltipSearchPeople: "從選定的公司中尋找潛在客戶",
  tooltipFilter: "篩選",
  tooltipSequence: "工作流程",
  tooltipSave: "儲存至列表",
  textFindPeople: "尋找人員",

  // recent mode
  recentMode: "最近模式",
  tryRealTimeAgain: "再次嘗試即時模式",
  realTimeResultsAreTemporarilyPaused: '由於 API 限制，即時結果已暫時暫停',

  // company-detail
  companies: "公司",

  // recent search
  popularUseCases: "熱門用例",
  skipTheGuesswork: "避免瞎猜 — 從熱門篩選組合開始。",
  labelRecentSearches: "最近的搜尋",
  labelRecentSavedFilters: "最近儲存的篩選條件",
  useThisFilterSetup: "使用此篩選器設定",
  startByApplyingFilters: "請從左側面板開始套用篩選器，以發現相關的聯絡人和公司。",


  //
  k: '千',

  filterAdvertisementStartDateSubTitle: "廣告開始日期區間",
  filterAdvertisementEndDateSubTitle: "廣告結束日期區間",
  filterAdvertisementSearchTermsSubTitle: "廣告搜尋詞",
  filterAdvertisementExcludeTargetLocation: "排除目標地點",
  active_filters_count: "1 個篩選條件 | {count} 個篩選條件",
  company_list: "公司清單",
  filter_presets: "篩選預設",
  my_list: "我的清單",
  company_profile: "公司簡介",
  people_workforce: "人員與勞動力",
  technology_presence: "技術與覆蓋範圍",
  saved_searches_count: "{count} 個已儲存",
  filterJobExcludeLocation: "排除職位地點",

  enter_keywords: "輸入關鍵字",
  filter_keywords_description_search_title: "在描述中搜尋",
  filter_keywords_description_search_tooltip: "在公司描述中搜尋關鍵字。",
  filter_places_description_search_title: "排除特定地點",
  filter_places_description_search_tooltip: "從搜尋結果中排除特定地點。",
  enter_places: "輸入地點",
  enterAdvertisementSearchTerms: "輸入搜尋詞，然後按Enter鍵...",
  people_list: "人員清單",
  clear: "清除",
  places: "地點",

  expand_filters: "開啟篩選",
  collapse_filters: "關閉篩選",
};
